module.exports = __webpack_public_path__ + "static/img/mq_logo.d11b7bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mq_logo.png
// module id = xUi2
// module chunks = 3